import React, { useState, useEffect, lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./influencer.css";
import htmlParser from "html-react-parser";

export default function Influencer({ influencerData }) {
  return (
    <>
      <div className="influencerSection pt-mobile-2 mb-5">
        <Container>
          <Row>
            <Col sm={12} className="influencerSectionheding">
              <div className="influencerHeading">
                <h4 className="alltextAnchorMorganeX">{htmlParser(influencerData.influencerHeading1)}</h4>
              </div>
            </Col>

            <Col sm={12} className="step-section">
              <ol>
              <li className="alltextAnchorMorgan">{htmlParser(influencerData.influencerPoints1)}</li>
                <li className="alltextAnchorMorgan">{htmlParser(influencerData.influencerPoints2)}</li>
                <li className="alltextAnchorMorgan">{htmlParser(influencerData.influencerPoints3)}</li>
              </ol>
            </Col>
            <p className="subtextinfluencer alltextAnchorMorgan">
              {htmlParser(influencerData.influencersubtext1)}
            </p>
          </Row>
        </Container>
      </div>
    </>
  );
}
